import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import CapEditTextAreaField from 'src/components/CapFieldsNew/CapEditTextAreaField';
import s from 'src/components/CapActionNew/CapAction.styles';

export const CapActionComments = ({
  canAddComment = false,
  isEditable = false,
  originalComments,
  comments,
  handleAddComment,
  removeComment,
  isCapManager,
  currentUserId 
}) => {
  const { t } = useTranslation();
  const [showCommentInput, setShowCommentInput] = useState(false);

  const commentAddedBy = (v) => {
    if (v.submittedByUser) {
      return `${v.submittedByUser.firstName} ${v.submittedByUser.lastName}`;
    }

    return '';
  };

  const handleCommentBlur = (comment, item) => {
    if (!comment) {
      setShowCommentInput(false);
      const indx = comments.findIndex(val => val.id === null);
      if (indx !== -1) {
        removeComment(indx);
      }
    } else if(!item){
      handleAddComment(comment);
    }else {
      handleAddComment(comment, item.id);

    }
  };

  return <>
    <div className='d-flex pl-8'>
      <s.Title>{t('COMMENT')}</s.Title>
      { canAddComment && (
        <s.AddCommentIcon name="btnAdd" onClick={() => setShowCommentInput(!showCommentInput)} />
      )}
    </div>
    { (canAddComment || isCapManager) && (
      <s.AddCommentInput className={`collapsable ${showCommentInput ? 'expanded' : ''}`}>
        <CapEditTextAreaField
            isEditable={isEditable}
            name="comment"
            wrapperClassName="eiqWrapper CommentInputWrapper" 
            rows={2}
            onBlur={handleCommentBlur}        
          />
      </s.AddCommentInput>
    )}
    { originalComments.map(v => {
      return !(v.submittedBy === null && v.createdBy === currentUserId) ?  
      <div key={v.id} className='pl-8'>
        <s.Comment>{v.comment}</s.Comment>
        <div className='d-flex'>
          <s.TitleSmall className='not-mandatory'>{commentAddedBy(v)}</s.TitleSmall>
          { v.submittedAt && (
            <>
              <s.Separator />
              <s.CommentDate>{moment(v.submittedAt).utc().format('D-MMM-YYYY [at] HH:mm')}</s.CommentDate>
            </>
          )}
        </div>
      </div>
      : <CapEditTextAreaField
        isEditable={isEditable}
        name="comment"
        wrapperClassName="eiqWrapper CommentInputWrapper " 
        rows={2}
        onBlur={(inputValue) => handleCommentBlur(inputValue, v)}    
        value={v.comment} 
        editCommentClassname={'editFromList'}   
      />
    })}
  </>
}
